<p class="links-container">
  <a href="{{ config.termsAndConditionsLink }}" target="_blank" class="web-links">
    {{ 'menus.termAndConditions' | translate }}
  </a>
  <a href="{{ config.privacyPolicyLink }}" target="_blank" class="web-links">
    {{ 'menus.privacyPolicy' | translate }}
  </a>
  <a href="{{ config.cookiePolicyLink }}" target="_blank" class="web-links">
    {{ 'menus.cookiePolicy' | translate }}
  </a>
  <a (click)="downloadHelpPdf()" target="_blank" class="web-links">
    {{ 'menus.instructionsForUse' | translate }}
  </a>
  <a (click)="downloadQuickStartGuide()" target="_blank" class="web-links">
    {{ 'menus.quickStartGuide' | translate }}
  </a>
  <a style="min-width: 100px !important;padding-top: 0px !important;">
    <app-language-switcher [parentName]="'sign_in'"></app-language-switcher>
  </a>
</p>